import React, { useEffect } from 'react';
import { FormInputType } from '../../shared/common/enums';
import FormFieldInputType from '../../shared/components/formInputType/formInputType';
import { useHistory, useParams } from 'react-router-dom';
import { FormFields } from '../../shared/common/interfaces';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { CreateBusinessPartner, UpdateBusinessPartner } from '../../shared/common/graphqlQuery';
import { companyData } from '../../core/auth';
import { routeConfig } from '../../shared/common/constant';
import { hideSuggestions, validateLabelMessages } from '../../shared/hooks/utils';
import { useStore } from '../../shared/hooks/stateStore';
import { Button, Checkbox, Form, Input, Select } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

let businessPartnerData;
const renderOption = (eachOption: any) => {
    return (
        <Select.Option value={eachOption.key ? eachOption.key : eachOption.value}
            key={eachOption.key ? eachOption.key : eachOption.value}>
            {eachOption.value}
        </Select.Option>
    )
}

const partnerType: any = [
    { key: '1', value: 'Buyer' },
    { key: '2', value: 'Supplier' }
];

let bankDetailsCheckbox = false;

const Consignee = () => {
    const [form] = Form.useForm();
    const companyId = companyData().getCompanyData();
    const { businessPartnerId } = useParams<any>();
    const history = useHistory();
    const goToUrl = (url) => {
        history.push('bank/' + url);
    }
    const redirectBack = () => {
        history.push(routeConfig.consigneeList.path);
    }
    useEffect(() => {
        bankDetailsCheckbox = false;
        hideSuggestions();
    }, []);

    if (businessPartnerId) {
        businessPartnerData = useStore.getState().consigneeData;
        if (!businessPartnerData) {
            redirectBack();
        }
    } else {
        businessPartnerData = null
    }

    const onSubmitted = (result: any) => {
        if (businessPartnerId || bankDetailsCheckbox) {
            redirectBack();
        } else {
            goToUrl(result.createBusinessPartner._id);
        }
    }

    const onError = (error: any) => {
        console.log(error, 'ee');
    }
    const { callMutation, loading } = useMutationHook(CreateBusinessPartner, onSubmitted, onError);
    const UpdateBusinessPartnerMutation = useMutationHook(UpdateBusinessPartner, onSubmitted, onError);

    const onFinish = (values: any) => {
        if (!loading && !UpdateBusinessPartnerMutation.loading) {
            values.email = values.email ? values.email.toLowerCase() : '';
            if (businessPartnerId) {
                UpdateBusinessPartnerMutation.callMutation({ variables: { input: { ...values, companyId, businessPartnerId } } });
            } else {
                callMutation({ variables: { businessPartnerInput: { ...values, companyId } } });
            }
        }
    };
    const setBankDetailsCheckbox = (e) => {
        bankDetailsCheckbox = e.target.checked;
    }
    return (
        <div className="form-wrapper">
            <Form
                name="basic"
                layout="vertical"
                onFinish={onFinish}
                // validateTrigger='onSubmit'
                validateMessages={validateLabelMessages}
                scrollToFirstError={true}
                initialValues={businessPartnerData}
            >
                <Form.Item
                    name='name'
                    label="Business Partner Name"
                    rules={[{ required: true, whitespace: true}]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name='partnerType' label='Business Partner Type' rules={[{ required: true }]}>
                    <Select
                        showSearch
                        optionFilterProp="children"
                        placeholder='Select Business Partner Type'
                        // onChange={onChangeTaxType}
                        // onFocus={onFocus}
                        // onBlur={onBlur}
                        // onSearch={onSearch}
                        // className="my-selector-class"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {partnerType.map((eachOption: any) => (
                            renderOption(eachOption)
                        ))
                        }
                    </Select>
                </Form.Item>
                <Form.Item
                    name='address'
                    label="Business Partner Address"
                    // rules={[{ required: true }]}
                >
                    <Input.TextArea />
                </Form.Item>
                <Form.Item
                    name='country'
                    label="Business Partner Country"
                    // rules={[{ required: true }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name='email'
                    label="Business Partner E-mail"
                    rules={[{ type: 'email' }]}
                >
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name='phoneNumber'
                    label="Phone Number "
                >
                    <Input autoComplete="off" />
                </Form.Item>
                {!businessPartnerId && <Form.Item>
                    <Checkbox onChange={setBankDetailsCheckbox}> Fill bank details later</Checkbox>
                </Form.Item>}
                <Form.Item>
                    <Button type="primary" ghost htmlType="submit" className="btn" onKeyDown={onFinish} style={{ width: 75 }}>
                        {(loading || UpdateBusinessPartnerMutation.loading) ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>
                    <Button danger type="ghost" onClick={redirectBack} style={{ width: 75 }}>
                        Cancel
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
export default Consignee